import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';

@Component({
  selector: 'app-search-with-multi-select-checkbox',
  templateUrl: './search-with-multi-select-checkbox.component.html',
  styleUrls: ['./search-with-multi-select-checkbox.component.scss'],
})
export class SearchWithMultiSelectCheckboxComponent implements OnInit {
  @Input() type: any;
  @Input() assignedStaffList: any[];
  @ViewChild('search', { read: ElementRef }) searchbarRef: ElementRef<HTMLElement>;
  usersList = [];
  filteredUsers = [];
  selectedUsers: any[] = [];
  constructor(public modalController: ModalController,
    public sharedValue: ShareValuesService,
    private backendCallService: BackendCallService,
    private toastService: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.selectedUsers = [];
  }

  /**
   * Gets users
   *
   * @param event event
   */
  public getUsers(event) {
    const searchTerm = event.detail.value.toLowerCase();
    this.filteredUsers = [];
    if (searchTerm.length >= 3) {
      this.assignNewUser(searchTerm);
    }
  }
  /**
   * Determines whether checkbox change on
   *
   * @param user user
   */
  onCheckboxChange(user: any) {
    this.syncSelectedUsers(user);
  }

  onEnterToggle(user: any, event: KeyboardEvent) {
    event.preventDefault();
    user.selected = !user.selected;
    this.syncSelectedUsers(user);
  }

  onSearchbarFocus() {
    this.moveSearchbarCaretToEnd();
    setTimeout(() => this.moveSearchbarCaretToEnd(), 0);
    setTimeout(() => this.moveSearchbarCaretToEnd(), 50);
  }

  private async moveSearchbarCaretToEnd() {
    const searchbar = this.searchbarRef?.nativeElement as (HTMLElement & { getInputElement?: () => Promise<HTMLInputElement> }) | undefined;
    if (!searchbar) {
      return;
    }

    const input = searchbar.getInputElement
      ? await searchbar.getInputElement()
      : searchbar.shadowRoot?.querySelector('input');

    if (!input) {
      return;
    }

    const textLength = input.value?.length || 0;
    input.focus();
    input.setSelectionRange(textLength, textLength);
  }

  private syncSelectedUsers(user: any) {
    const existingIndex = this.selectedUsers.findIndex(selectedUser => selectedUser.Id === user.Id);
    if (user.selected) {
      if (existingIndex === -1) {
        this.selectedUsers.push(user);
      }
      return;
    }

    if (existingIndex !== -1) {
      this.selectedUsers.splice(existingIndex, 1);
    }
  }

  /**
   * Assigns new user
   *
   * @param searchValue searchValue
   */
 assignNewUser(searchValue) {
  this.usersList = [];
  const payload = searchValue;
  this.backendCallService.getUser(payload).subscribe(
    (data: any) => {
      if (data.value && data.value.length > 0) {
        this.usersList = data.value;        
        const selectedIds = this.selectedUsers.map(u => u.Id);

        this.filteredUsers = this.usersList
          .filter(element => 
            !selectedIds.includes(element.id)
            &&
            !this.assignedStaffList.some(user => user.emailAdd === element.email))
          .map(element => ({
            Display_Name: element.name,
            Id: element.id,
            UserEmail: element.email
          }));
      } else {
        this.filteredUsers = [];
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      }
    }, err => {
      this.filteredUsers = [];
      this.toastService.presentToast(this.translate.instant('something_went_wrong'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }
  );
}

  /**
   * Closes search with multi select checkbox component
   */
  public close() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  /**
   * Assigns project
   */
  public assignProject() {
    this.modalController.dismiss({
      selectedUsers: this.selectedUsers,
      modeType: this.type
    });
  }

  removeAddUser(data) {
    const selectedData = this.selectedUsers.find((item) => item.Id === data.Id);
      if(selectedData){
        this.selectedUsers.forEach((item, index, object) => {
          if (item.Id === data.Id) {
            object.splice(index, 1);
          }
        });
        if (selectedData && selectedData.selected) {selectedData.selected = false;}
      }
  }
}
